import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse, HttpHeaders } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';

import { environment } from '../../../environments/environment';

declare var document: any;
declare var jQuery: any;
declare var window: any;

@Injectable()
export class HttpClientService {
  private activeRequests: number = 0;

  constructor(private http: HttpClient, private cookieService: CookieService) {}

  showAjaxLoader(): void {
    this.activeRequests += 1;
    jQuery('#ajax_loader_actual').show();
  }

  hideAjaxLoader(): void {
    this.activeRequests = Math.max(this.activeRequests - 1, 0);
    if (this.activeRequests === 0) jQuery('#ajax_loader_actual').hide();
  }

  buildHeaders(): HttpHeaders {
    //let headers: HttpHeaders = new HttpHeaders({'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content});
    //headers.set('Authorization', this.authService.buildAuthorizationHeader());
    let token: string = window.localStorage.getItem('token');
    let intranetId: string = (
      window.sessionStorage.getItem('intranetId') ||
      window.localStorage.getItem('intranetId') ||
      this.cookieService.get('intranetId')
    );
    let headersConfig: any = { 'X-intranet': intranetId || '' };
    if (token && token !== 'null' && token !== 'undefined') {
      headersConfig['Authorization'] = `Bearer ${token}`;
    }
    let headers: HttpHeaders = new HttpHeaders(headersConfig);
    return headers;
  }

  buildHttpParams(params: any): HttpParams {
    let httpParams: HttpParams = new HttpParams();
    for (let key in params)
      if (params.hasOwnProperty(key)) {
        if (params[key] instanceof Array) {
          let paramsArrayValue: Array<any> = params[key];
          for (let value of paramsArrayValue) if (value) httpParams = httpParams.append(`${key}[]`, value);
        }else if (params[key] instanceof Object) {
          let paramsObjectValue: any = params[key];
          for (let objectKey in paramsObjectValue){
            if (objectKey && paramsObjectValue.hasOwnProperty(objectKey)){
              httpParams = httpParams.append(`${key}[${objectKey}]`, paramsObjectValue[objectKey]);
            }
          }
        } else if (params[key]) httpParams = httpParams.set(key, params[key]);
      }
    return httpParams;
  }

  buildNewPageUrl(url: string, params: any = {}): string {
    let httpParams: HttpParams = this.buildHttpParams(params);
    return `${url}?${httpParams.toString()}`;
  }

  get(url: string, params: any = {}): Promise<any> {
    if (environment.url) {
      if (String(url)[0] == '/' || String(environment.url)[0] == '/') url = `${environment.url}${url}`;
      else url = `${environment.url}/${url}`;
    }
    let httpParams: HttpParams = this.buildHttpParams(params)
    this.showAjaxLoader();
    return this.http
      .get(url, { headers: this.buildHeaders(), params: httpParams, withCredentials: true })
      .toPromise()
      .then((response) => {
        this.hideAjaxLoader();
        return response;
      })
      .catch((error) => {
        this.hideAjaxLoader();
        throw error;
      });
  }

  getObservable(url: string, params: any = {}): Observable<any> {
    if (environment.url) {
      if (String(url)[0] == '/' || String(environment.url)[0] == '/') url = `${environment.url}${url}`;
      else url = `${environment.url}/${url}`;
    }
    let httpParams: HttpParams = new HttpParams();
    for (let key in params)
      if (params.hasOwnProperty(key)) {
        if (params[key] instanceof Array) {
          let paramsArrayValue: Array<any> = params[key];
          for (let value of paramsArrayValue) if (value) httpParams = httpParams.append(`${key}[]`, value);
        } else if (params[key]) httpParams = httpParams.set(key, params[key]);
      }
    this.showAjaxLoader();
    return this.http.get(url, { headers: this.buildHeaders(), params: httpParams }).pipe(
      map((response: any) => {
        this.hideAjaxLoader();
        return response;
      }),
      catchError((error: any) => {
        this.hideAjaxLoader();
        return observableThrowError(error.error || 'Server error');
      })
    );
  }

  patch(url: string, data: any): Promise<any> {
    if (environment.url) {
      if (String(url)[0] == '/' || String(environment.url)[0] == '/') url = `${environment.url}${url}`;
      else url = `${environment.url}/${url}`;
    }
    this.showAjaxLoader();
    return this.http
      .patch(url, data, { headers: this.buildHeaders() })
      .toPromise()
      .then((response) => {
        this.hideAjaxLoader();
        return response;
      })
      .catch((error) => {
        this.hideAjaxLoader();
        throw error;
      });
  }

  post(url: string, data: any): Promise<any> {
    if (environment.url) {
      if (String(url)[0] == '/' || String(environment.url)[0] == '/') url = `${environment.url}${url}`;
      else url = `${environment.url}/${url}`;
    }
    this.showAjaxLoader();
    return this.http
      .post(url, data, { headers: this.buildHeaders(), withCredentials: true })
      .toPromise()
      .then((response) => {
        this.hideAjaxLoader();
        return response;
      })
      .catch((error) => {
        this.hideAjaxLoader();
        throw error;
      });
  }

  put(url: string, data: any): Promise<any> {
    if (environment.url) {
      if (String(url)[0] == '/' || String(environment.url)[0] == '/') url = `${environment.url}${url}`;
      else url = `${environment.url}/${url}`;
    }
    this.showAjaxLoader();
    return this.http
      .put(url, data, { headers: this.buildHeaders() })
      .toPromise()
      .then((response) => {
        this.hideAjaxLoader();
        return response;
      })
      .catch((error) => {
        this.hideAjaxLoader();
        throw error;
      });
  }

  delete(url: string, params: any = {}): Promise<any> {
    if (environment.url) {
      if (String(url)[0] == '/' || String(environment.url)[0] == '/') url = `${environment.url}${url}`;
      else url = `${environment.url}/${url}`;
    }
    let httpParams: HttpParams = this.buildHttpParams(params)
    this.showAjaxLoader();
    return this.http
      .delete(url, { headers: this.buildHeaders(), params: httpParams })
      .toPromise()
      .then((response) => {
        this.hideAjaxLoader();
        return response;
      })
      .catch((error) => {
        this.hideAjaxLoader();
        throw error;
      });
  }

  setNewPageUrl(url: string) {
    window.history.pushState({}, '', url);
  }
}
